/* jQuery required */
jQuery(function($){
  var $drawer = $('#mobileDrawer');
  var $body = $('body');

  function openDrawer(){
    $drawer.addClass('active').attr('aria-hidden','false');
    $('#mobileToggle').attr('aria-expanded','true');
    $body.css('overflow','hidden');
  }

  function closeDrawer(){
    $drawer.removeClass('active').attr('aria-hidden','true');
    $('#mobileToggle').attr('aria-expanded','false');
    $body.css('overflow','');

    // reset all submenus
    $drawer.find('.has-children').removeClass('open');
    $drawer.find('.offcanvas-submenu').hide();
  }

  $('#mobileToggle').on('click', openDrawer);
  $('#drawerClose, #drawerOverlay').on('click', closeDrawer);

  // Toggle submenu (CodePen-style)
  $drawer.on('click', '.sub-menu-toggle', function(e){
    e.preventDefault();
    e.stopPropagation();

    var $li = $(this).closest('.has-children');
    var $submenu = $li.children('.offcanvas-submenu');

    // close siblings at same level for a cleaner UX
    var $siblings = $li.siblings('.has-children');
    $siblings.removeClass('open').children('.offcanvas-submenu').slideUp(180);

    // toggle current
    $li.toggleClass('open');
    $submenu.stop(true,true).slideToggle(180);
  });

  // Allow Enter/Space on the toggle
  $drawer.on('keydown', '.sub-menu-toggle', function(e){
    if(e.key === 'Enter' || e.key === ' '){
      e.preventDefault();
      $(this).trigger('click');
    }
  });


  $(document).on('click', '.product__accordion details > summary', function (e) {
  const $details = $(this).closest('details');

    $('.product__accordion details').not($details).removeAttr('open');

  });


});